import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LogDropzone from "./LogDropzone";

/**
 * Modal wrapper around the dropzone. Keeps the upload surface out of the way
 * until it's needed — the main view is the list of logs, not the uploader.
 */
const UploadLogModal = ({ open, onClose, onUploaded }) => {
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1 }}>
        <span>Upload flight log</span>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
          ArduPilot .bin / .log, PX4 .ulg or MAVLink .tlog — parsed on our servers into a health summary.
        </Typography>
        <Box>
          <LogDropzone
            onUploaded={(logId) => {
              onUploaded?.(logId);
              onClose?.();
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UploadLogModal;
